// URL search serialization. TanStack Router's default JSON-quotes any string that looks like JSON
// (?archived=%22true%22). We keep plain query strings, so shared links read like Drata's
// (/controls?archived=true&f_readiness=READY,NOT_READY&q=mfa). Objects, arrays and strings that would be ambiguous
// still round-trip through JSON.
import { parseSearchWith, stringifySearchWith } from '@tanstack/react-router'

/** Parses only values written as JSON objects, arrays or quoted strings; everything else stays a plain string. */
function jsonOnly(value: string): unknown {
  const c = value.charAt(0)
  if (c === '{' || c === '[' || c === '"') return JSON.parse(value)
  throw new Error('plain string')
}

export const parseSearch = parseSearchWith(jsonOnly)
export const stringifySearch = stringifySearchWith(JSON.stringify, jsonOnly)
